module.exports = __webpack_public_path__ + "static/vsfactorym-6bd2aa019eab40d8fc6713fddf5300df.png";